import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative overflow-hidden sm:col-span-2 lg:col-span-2 group object-cover h-full w-full" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "absolute bottom-10 left-0 right-0 text-white w-full flex flex-col items-center justify-between transition-transform duration-500 group-hover:translate-y-[-10px]" }
const _hoisted_4 = { class: "max-w-3/5 flex flex-col items-center justify-between text-center" }
const _hoisted_5 = { class: "text-base tracking-wide mb-4" }
const _hoisted_6 = { class: "mt-2 text-3xl" }
const _hoisted_7 = ["src", "alt", "title"]

import {ref} from 'vue'
import type {CatalogBannerType} from "@/assets/ts/typeCatalogBanner"
import ElementVideo from "@/components/elements/elementVideo.vue";

type bannerType = {
  imageSrc: string
  alt: string
  eyebrow: string
  title: string
}

interface Product {
  set_id: string;
  hash?: string;
  price: number;
  price_gold: number;
  price_platinum: number;
  metal: string;
  stones: string;
  image: {
    filename: string
    filename_layer: string
    positions: {
      filename: string

    }[]
  };
}

const fallbackMarketingImage = "https://rubin-website-images.s3.eu-central-1.amazonaws.com/conf/ru-6011/closeup/closeup-ru-6011_white.female.f2ba346d-e6ee-4e97.mp4"


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogBanner',
  props: {
    catalogBanners: { default: () => [] },
    item: {},
    index: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

/**
 * Banner
 */

const getNextBanner = (): false | bannerType => {
  if (props?.catalogBanners && props?.catalogBanners?.length > 0) {
    const bannerIdx = Math.floor((props.index - 4) / 8)
    if (props?.catalogBanners?.length > bannerIdx) {
      return props?.catalogBanners?.[bannerIdx] || false
    } else {
      return false
    }
  } else {
    return false
  }
}

const banner = ref<false | bannerType>(getNextBanner())

/**
 * get marketingBoxImage
 */

const getMarketingBoxImage = (item: Product) => {
  const positions: string[] = ["closeup-", "model-", "still-"]
  for (const positionIdx in positions) {
    for (const idx in item.image.positions) {
      const position: string = positions[positionIdx] || "";
      if (item.image.positions[idx]?.filename.includes(position)) {
        return item.image?.positions[idx]?.filename
      }
    }
  }
  return ""
}

const marketingImage = ref<string>(getMarketingBoxImage(props.item) || fallbackMarketingImage)

const onMarketingImageError = () => {
  if (marketingImage.value !== fallbackMarketingImage) {
    marketingImage.value = fallbackMarketingImage
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (banner.value !== false)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("img", {
            src: banner.value?.imageSrc,
            alt: banner.value?.alt,
            class: "h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(banner.value?.eyebrow), 1),
              _createElementVNode("h3", _hoisted_6, _toDisplayString(banner.value?.title), 1)
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (marketingImage.value.endsWith('.mp4'))
            ? (_openBlock(), _createBlock(ElementVideo, {
                key: 0,
                src: marketingImage.value,
                "video-class": "object-cover mx-auto w-full h-full relative z-30",
                onError: onMarketingImageError
              }, null, 8, ["src"]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: marketingImage.value,
                alt: __props.item.set_id,
                title: __props.item.set_id,
                class: "h-full w-full object-cover transition-transform duration-300 group-hover:scale-105",
                onError: onMarketingImageError
              }, null, 40, _hoisted_7))
        ], 64))
  ]))
}
}

})